import React, { FC } from 'react';

import { TableCell, TableRow } from '@material-ui/core';
import cx from 'classnames';

import { checkIsObject } from '../../../../../utils/helpers';
import { TABLE_CELL_COMPONENTS } from '../Table';
import useStyles from '../styles';

interface TableRowComponentProps {
  row: any;
  headingData: any;
  handleClickRow?: any;
  name?: string;
}

export const TableRowComponent: FC<TableRowComponentProps> = ({
  row,
  headingData,
  handleClickRow = null,
  name,
}) => {
  const styles = useStyles();

  const handleClick = () => {
    handleClickRow && handleClickRow();
  };

  return (
    <TableRow
      className={cx(
        styles.analyticsRow,
        styles.tableBodyCell,
        handleClickRow && styles.clickableRow,
      )}
      onClick={handleClick}
      data-testid={name + 'BodyRow'}
    >
      {headingData.map((column) => {
        const k = column?.key;
        const columnType = column?.type;
        const render = column?.render;
        const isObject = checkIsObject(row[k]);
        const align = column?.align || 'left';

        if (TABLE_CELL_COMPONENTS[columnType]) {
          const cellComponent = TABLE_CELL_COMPONENTS[columnType];
          return cellComponent(styles, row, k, align);
        }

        if (isObject) {
          return (
            <TableCell key={k} className={styles.contentCell} align={align} title={row[k]?.title}>
              {row[k]?.display}
            </TableCell>
          );
        }

        return (
          <TableCell key={k} className={styles.contentCell} align={align}>
            {render ? render(row[k]) : row[k]}
          </TableCell>
        );
      })}
    </TableRow>
  );
};
